import { render, staticRenderFns } from "./RequestStatusBadge.vue?vue&type=template&id=f853b072&scoped=true&"
import script from "./RequestStatusBadge.vue?vue&type=script&lang=js&"
export * from "./RequestStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./RequestStatusBadge.vue?vue&type=style&index=0&id=f853b072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f853b072",
  null
  
)

component.options.__file = "RequestStatusBadge.vue"
export default component.exports